<template>
  <div class="c-view">
    <div class="c-attribe">
      <div class="c-panel">
        <Moduler title="页面属性设置">
          <Tabs v-model="panel">
            <TabPane name="system" label="基础信息">
              <RowForm v-model="pages">
                <row-item label="落地页名称" prop="pageInnerName" required>
                  <input-len v-model.trim="pages.pageInnerName" placeholder="内部管理" :max="40" width="342"></input-len>
                </row-item>

                <row-item label="页面名称" prop="pageName" required>
                  <input-len v-model.trim="pages.pageName" placeholder="外部显示" :max="40" width="342"></input-len>
                </row-item>
                <!-- <row-item label="地址文件夹" prop="path" required>
                  <input-len
                    v-model="pages.path"
                    placeholder=""
                    :max="30"
                    width="342"></input-len>
                </row-item> -->
                <row-item label="游戏组" prop="gameGroupId">
                  <auto-complete
                    v-model="pages.gameGroupId"
                    :data="groupData"
                    placeholder=""
                    width="342"
                    @on-select="handleGroup"
                  ></auto-complete>
                </row-item>
                <row-item label="游戏" prop="multGame" required>
                  <el-select multiple filterable v-model="pages.multGame" style="width: 342px" @change="clear">
                    <el-option v-for="item in gamesList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                  </el-select>
                </row-item>
                <row-item label="下载链接" prop="urlType">
                  <RadioGroup v-model="pages.urlType" type="button">
                    <Radio :label="1" :disabled="editState">单端自动生成</Radio>
                    <Radio :label="2" :disabled="editState">双端手动填写</Radio>
                  </RadioGroup>
                </row-item>
                <row-item label="按钮链接" v-if="pages.urlType === 1">
                  <Input readonly placeholder="自动链接应用程序下载地址" />
                </row-item>
                <row-item label="iOS链接" indent prop="iosUrl" required v-if="pages.urlType === 2">
                  <Input v-model="pages.iosUrl" placeholder="请输入iOS应用下载地址" />
                </row-item>
                <row-item label="安卓链接" indent prop="androidUrl" required v-if="pages.urlType === 2">
                  <Input v-model="pages.androidUrl" placeholder="请输入安卓应用下载地址" />
                </row-item>
                <row-item label="背景颜色" prop="bgColor">
                  <color-pick v-model="pages.bgColor"></color-pick>
                </row-item>
                <row-item label="背景图片" prop="bgImage">
                  <upload-image
                    v-model="pages.bgImage"
                    :size="10240"
                    :format="['jpg', 'jpeg', 'png', 'gif']"
                    @on-change="changeImage(pages, ...arguments)"
                  ></upload-image>
                </row-item>
              </RowForm>
            </TabPane>
            <TabPane name="compont" label="组件属性">
              <RowForm>
                <template v-for="(element, index) in attribute">
                  <row-item
                    v-if="element.element_type === 'TEXT' && element.parent === '' && (!element.relyon || textRelyon(element, attribute))"
                    :key="index"
                    :label="element.label"
                    :prop="element.name"
                    :required="element.required"
                  >
                    <row-alink
                      v-model="element[element.name]"
                      :name="element.label"
                      :readonly="element.restriction.readonly"
                      :pattern="element.restriction.pattern"
                      :disabled="element.restriction.disabled"
                      :placeholder="element.restriction.placeholder"
                      :clearable="element.restriction.clearable"
                      :verify="formErr"
                    />
                  </row-item>
                  <row-item
                    v-else-if="element.element_type === 'TEXTAREA' && element.parent === ''"
                    :key="index"
                    :label="element.label"
                    :prop="element.name"
                    :required="element.required"
                    flex-start
                  >
                    <row-textarea
                      v-model="element[element.name]"
                      :name="element.label"
                      :readonly="element.restriction.readonly"
                      :pattern="element.restriction.pattern"
                      :disabled="element.restriction.disabled"
                      :placeholder="element.restriction.placeholder"
                      :max="element.restriction.max"
                      :rows="3"
                      :overflow="false"
                      :verify="formErr"
                    />
                  </row-item>
                  <row-item
                    v-else-if="
                      element.element_type === 'GROUPBOX' && element.parent === '' && (!element.relyon || textRelyon(element, attribute))
                    "
                    flex-start
                    :key="index"
                    :label="element.label"
                    :prop="element.name"
                  >
                    <RadioGroup v-model="element[element.name]" type="button" @on-change="changeGroupBox(element.name, ...arguments)">
                      <Radio v-for="rio in element.restriction" :key="rio.value" :label="rio.value">
                        <Icon v-if="rio.icon" :type="rio.icon" />
                        <img v-if="rio.img" :src="rio.img" />
                        <template v-else>{{ rio.label }}</template>
                      </Radio>
                    </RadioGroup>
                    <p v-if="element.name === 'btnstyle' && element[element.name] === 'inline'">
                      <span class="g-error-text">注意：该样式不能用于头条批量建计划！！</span>
                    </p>
                  </row-item>
                  <row-item
                    v-else-if="element.element_type === 'STRUCT' && element.parent === ''"
                    :key="index"
                    :label="element.label"
                    :prop="element.name"
                    flex-start
                  >
                    <Row>
                      <Col span="12" v-for="(el, i) in element.children" :key="i">
                        <row-item
                          v-if="el.element_type === 'GROUPICON' && el.parent === element.name"
                          mini
                          :label="el.label"
                          :prop="el.name"
                        >
                          <i class="fa-solid fa-align-center"></i>
                          <RadioGroup v-model="el[el.name]" type="button" size="small">
                            <Radio v-for="rio in el.restriction" :key="rio.value" :label="rio.value">
                              <span v-if="rio.label.includes('align')" :class="`iconfont icon-${rio.label}`" />
                            </Radio>
                          </RadioGroup>
                        </row-item>
                        <row-item
                          v-else-if="el.element_type === 'GROUPMIXCHECK' && el.parent === element.name"
                          mini
                          :label="el.label"
                          :prop="el.name"
                        >
                          <Mixcheck v-model="el[el.name]" type="button" size="small">
                            <check-item v-for="rio in el.restriction" allow :key="rio.value" :label="rio.value">
                              <span v-if="rio.label === 'B'" style="font-weight: bold">{{ rio.label }}</span>
                              <span v-else-if="rio.label === 'I'" style="font-style: italic">{{ rio.label }}</span>
                              <span v-else-if="rio.label === 'U'" style="text-decoration: underline">{{ rio.label }}</span>
                            </check-item>
                          </Mixcheck>
                        </row-item>
                        <row-item
                          v-else-if="el.element_type === 'SELECTBOX' && el.parent === element.name"
                          mini
                          :label="el.label"
                          :prop="el.name"
                        >
                          <Select v-model="el[el.name]" size="small" style="width: 80px">
                            <Option v-for="sel in el.restriction" :key="sel.value" :value="sel.value" :disabled="sel.disabled">{{
                              sel.label
                            }}</Option>
                          </Select>
                        </row-item>
                      </Col>
                    </Row>
                  </row-item>
                  <row-item
                    v-else-if="element.element_type === 'SELECTBOX' && element.parent === ''"
                    :key="index"
                    :label="element.label"
                    :prop="element.name"
                  >
                    <Select v-model="element[element.name]" style="width: 100px">
                      <Option v-for="sel in element.restriction" :key="sel.value" :value="sel.value" :disabled="sel.disabled">{{
                        sel.label
                      }}</Option>
                    </Select>
                  </row-item>
                  <row-item
                    v-else-if="element.element_type === 'COLOR' && element.parent === ''"
                    :key="index"
                    :label="element.label"
                    :prop="element.name"
                  >
                    <color-pick v-model="element[element.name]"></color-pick>
                  </row-item>
                  <row-item
                    v-else-if="
                      element.element_type === 'UPLOAD' && element.parent === '' && (!element.relyon || textRelyon(element, attribute))
                    "
                    :key="index"
                    :label="element.label"
                    :prop="element.name"
                    :inline="element.inline"
                    required
                    flex-start
                  >
                    <upload-image
                      v-model="element[element.name]"
                      :verify="formErr"
                      :up-txt="element.up_txt"
                      :rules="element.rules"
                      :disabled-info="element.disabled_info"
                      :size="10240"
                      :format="['jpg', 'jpeg', 'png', 'gif']"
                      @on-change="changeImage(element, ...arguments)"
                    ></upload-image>
                  </row-item>
                  <row-item
                    v-else-if="element.element_type === 'SWITCH' && element.parent === ''"
                    :key="index"
                    :label="element.label"
                    :prop="element.name"
                  >
                    <i-switch v-model="element[element.name]" size="small" />
                  </row-item>
                  <row-item
                    v-else-if="element.element_type === 'SLIDER' && element.parent === ''"
                    :key="index"
                    :label="element.label"
                    :prop="element.name"
                  >
                    <Slider v-model="element[element.name]" show-input :min="element.restriction.min" :max="element.restriction.max" />
                  </row-item>
                  <row-item
                    v-else-if="
                      element.element_type === 'TIPS' && element.parent === '' && (!element.relyon || textRelyon(element, attribute))
                    "
                    :key="index"
                    :label="element.label"
                    :prop="element.name"
                  >
                    <span class="g-error-text" v-html="element[element.name]"></span>
                  </row-item>
                </template>
              </RowForm>
            </TabPane>
          </Tabs>
          <!-- 提交验证 -->
          <div class="c-group-submit">
            <Row :gutter="12">
              <Col span="12">
                <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="cannelError"></error-pop>
              </Col>
              <Col span="12" class-name="c-btns">
                <Button type="primary" :loading="saving" @click.stop="submit">
                  <span v-if="!saving">保存</span>
                  <span v-else>提交中...</span>
                </Button>
              </Col>
            </Row>
          </div>
        </Moduler>
      </div>
    </div>
    <div class="c-phone">
      <div class="c-p-box">
        <!-- 头部内容 -->
        <header>
          <img src="~@/assets/phone_head.png" width="100%" alt="" />
          <div class="h-title">
            <span>{{ pages.pageName }}</span>
          </div>
        </header>
        <!-- 中间内容 -->
        <section ref="phone" class="c-p-content">
          <template v-for="(element, index) in data">
            <switch-component
              v-if="element.id === 1"
              :key="index"
              :active="current === index"
              :attr="element.attr"
              :icon="element.icon"
              :pos="pos"
              @on-select="setCurrent(index)"
              @on-delete="del(index)"
            ></switch-component>
            <image-component
              v-if="element.id === 2"
              :key="index"
              :active="current === index"
              :attr="element.attr"
              :icon="element.icon"
              :index="index"
              @on-select="setCurrent(index)"
              @on-prev="prev(index)"
              @on-next="next(index)"
              @on-delete="del(index)"
            ></image-component>
            <slider-component
              v-if="element.id === 5"
              :key="index"
              :active="current === index"
              :attr="element.attr"
              :index="index"
              @on-select="setCurrent(index)"
              @on-prev="prev(index)"
              @on-next="next(index)"
              @on-delete="del(index)"
            ></slider-component>
            <text-component
              v-if="element.id === 6"
              :key="index"
              :active="current === index"
              :attr="element.attr"
              :index="index"
              @on-select="setCurrent(index)"
              @on-prev="prev(index)"
              @on-next="next(index)"
              @on-delete="del(index)"
            ></text-component>
          </template>
          <div class="before-div" :style="{ backgroundColor: pages.bgColor, backgroundImage: `url(${pages.bgImage})` }"></div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import validMixin from './valid-mixin'
import { HTML_CODE } from '../../data/htmlcode'
import { mul, div } from '@/common/js/api'
import { transArray, timeout, applyKey, isJSON, isArray } from '@/common/js/utils'
import { getPtomGroupGames, getPtomGames } from '@/api/material.model'
import { addLandPage, getLandPageById } from '@/api/landpage.model'

import Moduler from '../base/moduler'
import RowForm from '../base/row-form'
import RowItem from '../base/row-item'
import RowAlink from '../base/row-alink'
import RowTextarea from '../base/row-textarea'
import UploadImage from '../base/row-image'
import ColorPick from '../colorpick/color-pick'
import SwitchComponent from '../element/switch-component'
import ImageComponent from '../element/image-component'
import SliderComponent from '../element/slider-component'
import TextComponent from '../element/text-component'
import ErrorPop from '@/components/error-pop.vue'
import InputLen from '@/components/input/input-len.vue'
import AutoComplete from '@/components/autocomplete/autocomplete.vue'
import Mixcheck from '@/components/mixcheck'
import CheckItem from '@/components/mixcheck/check-item'
export default {
  name: 'edit',
  mixins: [validMixin],
  components: {
    Moduler,
    RowForm,
    RowItem,
    RowAlink,
    RowTextarea,
    ErrorPop,
    InputLen,
    AutoComplete,
    ColorPick,
    Mixcheck,
    CheckItem,
    SwitchComponent,
    ImageComponent,
    SliderComponent,
    TextComponent,
    UploadImage
  },
  props: {
    data: {
      type: Array
    },
    value: {
      type: String
    },
    current: {
      type: Number
    },
    attribute: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    panel: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    editState() {
      return this.$route.query.t === 'edit'
    },
    fixedLen() {
      return this.data.filter((ret) => ret.id === 1).length
    },
    dragArray() {
      return this.data.filter((ret) => [2, 3, 4].includes(ret.id))
    },
    switchComponent() {
      return (ret) => ret.id === 1
    },
    imageComponent() {
      return (ret) => [2, 5].includes(ret.id)
    },
    textComponent() {
      return (ret) => ret.id === 6
    },
    textRelyon() {
      return (element, attr) => {
        const { index, value } = element.relyon
        const ret = attr[index]
        return ret[ret.name] === value
      }
    }
  },
  methods: {
    getData() {
      getLandPageById({
        pageId: this.pages.pageId
      })
        .then((data) => {
          this.$Spin.hide()
          if (data) {
            let { gameIds, pageName, pageAttributes, urlType, iosUrl, androidUrl, pageInnerName } = data
            this.pages.pageName = pageName
            this.pages.pageInnerName = pageInnerName
            this.pages.iosUrl = iosUrl
            this.pages.androidUrl = androidUrl
            this.pages.urlType = urlType || 1
            // 多选游戏
            gameIds = applyKey(gameIds)
            this.pages.multGame = gameIds.map((ret) => parseInt(ret))
            // JSON
            if (isJSON(pageAttributes)) {
              pageAttributes = JSON.parse(pageAttributes)
              const { pagesAttr, componentAttr } = pageAttributes
              // 页面属性
              if (pagesAttr) {
                const { bgColor, bgImage } = pagesAttr
                bgColor && (this.pages.bgColor = bgColor)
                bgImage && (this.pages.bgImage = bgImage)
              }
              // 组件
              if (isArray(componentAttr)) {
                componentAttr.forEach((ret) => {
                  this.$emit('on-add', { type: ret.id, props: ret })
                })
              }
            }
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    // 选择游戏组
    handleGroup(meta) {
      this.pages.gameGroupId = meta.id
      if (meta.children) {
        const child = meta.children.map((ret) => parseInt(ret))
        this.pages.multGame = child.filter((ret) => this.gamesList.map((met) => met.id).includes(ret))
        timeout(500).then(() => {
          this.groupState = true
        })
      }
    },
    changeGroupBox() {
      const name = arguments[0]
      const value = arguments[1]
      this.$emit('on-change-groupbox', { name, value })
    },
    changeImage() {
      const element = arguments[0]
      const image = arguments[1]
      Object.assign(element, image)
    },
    cannelError() {},
    clear() {
      if (this.groupState) {
        this.pages.gameGroupId = ''
        this.groupState = false
      }
    },
    setCurrent(index) {
      this.$emit('update:current', index)
      this.$emit('input', 'compont')
    },
    prev(index) {
      const tIndex = index - 1
      if (tIndex >= this.fixedLen) {
        transArray(this.data, index, 'prev')
        this.$emit('update:current', tIndex)
      } else {
        this.$Message.error('已经到顶了！')
      }
    },
    next(index) {
      const tIndex = index + 1
      const len = this.data.length
      if (tIndex < len) {
        transArray(this.data, index, 'next')
        this.$emit('update:current', tIndex)
      } else {
        this.$Message.error('已经到底了！')
      }
    },
    del(index) {
      const tIndex = index - 1
      this.data.splice(index, 1)
      this.$emit('update:current', tIndex < 0 ? 0 : tIndex)
    },
    scrollBottom() {
      const centent = this.$refs.phone
      centent.scrollTo(0, 19200)
    },
    preloadData() {
      this.$Spin.show()
      Promise.all([getPtomGames(), getPtomGroupGames()])
        .then((data) => {
          const [game, group] = data
          game && (this.gamesList = game)
          if (group) {
            this.groupData = group.map((ret) => {
              return {
                id: ret.groupId,
                name: ret.groupName,
                children: ret.gameIds
              }
            })
          }
          if (this.pages.pageId) this.getData()
          else this.$Spin.hide()
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    replaceHtml(html) {
      let htmlCode = JSON.parse(JSON.stringify(html))

      // 页面属性
      htmlCode = htmlCode.replace(/PAGE_NAME/, this.pages.pageName)
      htmlCode = htmlCode.replace(/PAGE_COLOR/, this.pages.bgColor)
      htmlCode = htmlCode.replace(/PAGE_IMAGE/, this.pages.bgImage)

      // 组件属性
      if (isArray(this.data)) {
        const containerHtml = this.data
          .map((ret) => {
            if (this.switchComponent(ret)) {
              const material = {}
              ret.attr.forEach((met) => {
                material[met.name] = met[met.name]
              })
              return `
              <div class="con_fixed con_fixed_${material.position}" style="background-color:${material.color}">
                ${material.btn_bg_image ? `<img src="${material.btn_bg_image}" width="100%" alt="" />` : ''}
                <div class="c-complete ${material.btnstyle !== 'block' ? 'c-complete-padding' : ''} ${
                material.align !== 'center' ? 'c-complete-end' : ''
              } ${material.btn_bg_image ? 'c-complete__bgimage' : ''}">
                  <a href="javascript:;"><img src="${material.image}"${
                material.btnstyle === 'block' ? ' width="100%" height="100%" ' : ''
              } alt="" onclick="down()" /></a>
                </div>
              </div>
            `
            } else if (this.imageComponent(ret)) {
              const material = {}
              ret.attr.forEach((met) => {
                material[met.name] = met[met.name]
              })
              if (ret.id === 2) {
                return `
              <ul class="list_ul">
                <li>
                  <div class="con_ima_a">${material.downlink ? `<a href="${material.href}">` : ''}<img src="${material.image}" />${
                  material.downlink ? '</a>' : ''
                }</div>
                </li>
              </ul>
            `
              } else if (ret.id === 5) {
                return `
              <ul class="list_ul">
                <li>
                  <div style="background-color: ${material.color}; height: ${material.height}px;"></div>
                </li>
              </ul>
            `
              }
            } else if (this.textComponent(ret)) {
              const material = {}
              ret.attr.forEach((met) => {
                if (isArray(met.children)) {
                  met.children.forEach((m) => {
                    material[m.name] = m[m.name]
                  })
                } else material[met.name] = met[met.name]
              })
              const fontStyle = material.font_style
                .map((met) => {
                  if (met === 'bold') return 'font-weight: bold;'
                  else if (met === 'italic') return 'font-style: italic;'
                  else if (met === 'underline') return 'text-decoration: underline;'
                })
                .join('')
              return `
              <p style="color: ${material.color}; line-height: ${material.line_height}; font-size: ${material.font_size}px; text-align: ${
                material.text_align
              }; letter-spacing: ${material.letter_spacing}; ${fontStyle}">${
                material.link ? `<a href="${material.href}">` : ''
              }${material.text.replace(/\n/g, '<br />')}${material.link ? '</a>' : ''}</p>
            `
            }
          })
          .join('')
        // 替换内容
        htmlCode = htmlCode.replace(/{CONTAINER_HTML}/, containerHtml)
        htmlCode = htmlCode.replace(/{URL_TYPE}/, this.pages.urlType)
        htmlCode = htmlCode.replace(/{IOS_URL}/, `"${this.pages.iosUrl}"`)
        htmlCode = htmlCode.replace(/{ANDROID_URL}/, `"${this.pages.androidUrl}"`)
      }

      return htmlCode
    },
    buildAttribute() {
      let componentAttr
      const pagesAttr = { id: 0, bgImage: this.pages.bgImage, bgColor: this.pages.bgColor }
      if (isArray(this.data)) {
        componentAttr = this.data.map((ret) => {
          if (this.switchComponent(ret)) {
            const material = {}
            ret.attr.forEach((met) => {
              material[met.name] = met[met.name]
              if (met.name === 'image') {
                material.width = met.width
                material.height = met.height
              }
            })
            return {
              id: 1,
              image: material.image,
              color: material.color,
              position: material.position,
              btnstyle: material.btnstyle,
              align: material.align,
              btn_bg_image: material.btn_bg_image,
              text: material.text,
              width: material.width,
              height: material.height
            }
          } else if (this.imageComponent(ret)) {
            let component
            const material = {}
            ret.attr.forEach((met) => {
              material[met.name] = met[met.name]
              if (met.name === 'image') {
                material.width = met.width
                material.height = met.height
              }
            })
            if (ret.id === 2) {
              component = {
                id: 2,
                image: material.image,
                downlink: material.downlink,
                href: material.href,
                width: material.width,
                height: material.height
              }
            } else if (ret.id === 5) component = { id: 5, color: material.color, height: material.height }
            return component
          } else if (this.textComponent(ret)) {
            const material = {}
            ret.attr.forEach((met) => {
              if (isArray(met.children)) {
                met.children.forEach((m) => {
                  material[m.name] = m[m.name]
                })
              } else material[met.name] = met[met.name]
            })
            return {
              id: 6,
              text: material.text,
              font_family: material.font_family,
              font_size: material.font_size,
              color: material.color,
              link: material.link,
              href: material.href,
              format: {
                letter_spacing: material.letter_spacing,
                line_height: material.line_height,
                font_style: material.font_style,
                text_align: material.text_align
              }
            }
          }
        })
      } else componentAttr = []
      return { pagesAttr, componentAttr }
    },
    buildTouTiaoAttr() {
      let toutiaoAttr = []
      if (isArray(this.data) && this.data.length) {
        toutiaoAttr = this.data.map((ret) => {
          const material = {}
          if (ret.key === 'XrButton' && isArray(ret.attr)) {
            const align = ret.attr.filter((met) => met.name === 'align').pop()
            const { btnstyle } = ret.attr.filter((met) => met.name === 'btnstyle').pop()
            const floatBool = align && align.align && align.align === 'end'
            ret.attr
              .filter((met) => met.key)
              .forEach((met) => {
                if (met.key === 'float' && floatBool) material[met.key] = 'right'
                else material[met.key] = met[met.name]
                if (met.key === 'bg_image' && met.width && met.height) {
                  if (btnstyle === 'block' || met.width >= 750) material.height = Math.floor(div(mul(375, met.height), met.width))
                  else material.height = Math.floor(div(met.height, 2))
                }
              })
            Object.assign(material, { name: ret.key, bg_type: 'image' })
          } else if (ret.key === 'XrPicture' && isArray(ret.attr)) {
            const { href } = ret.attr.filter((met) => met.name === 'href').pop()
            ret.attr
              .filter((met) => met.key)
              .forEach((met) => {
                material[met.key] = met[met.name]
                if (met.key === 'image_url' && met.width && met.height) {
                  material.height = Math.floor(div(mul(375, met.height), met.width))
                }
                if (material.link) material.link = { url: href, link_type: 'url' }
                else delete material.link
              })
            Object.assign(material, { name: ret.key })
          } else if (ret.key === 'XrSimpleText' && isArray(ret.attr)) {
            const { href } = ret.attr.filter((met) => met.name === 'href').pop()
            ret.attr.forEach((met) => {
              if (isArray(met.children)) {
                met.children.forEach((m) => {
                  if (m.key) material[m.key] = m[m.name]
                })
              } else if (met.key) material[met.key] = met[met.name]
              if (material.link) material.link = { url: href, link_type: 'url' }
              else delete material.link
            })
            Object.assign(material, { name: ret.key })
          }
          return material
        })
      }
      return toutiaoAttr
    },
    submit() {
      this.errRes = [...this.valid()]
      if (this.errRes.length) {
        this.formErr = true
        return
      }
      const index = this.customValid(this.data)
      if (index > -1) {
        this.formErr = true
        this.errRes.push({ feild: '自定义组件', msg: '自定义组件中的值验证不通过！' })
        this.setCurrent(index)
        return
      }

      // html_code
      const htmlCode = this.replaceHtml(this.htmlCode)

      const params = Object.assign({}, this.pages, {
        gameIdStr: this.pages.multGame.join(','),
        urlType: this.pages.urlType,
        iosUrl: this.pages.iosUrl,
        androidUrl: this.pages.androidUrl,
        pageAttributes: JSON.stringify(this.buildAttribute()),
        touTiaoAttr: JSON.stringify(this.buildTouTiaoAttr()),
        htmlCode
      })
      // 删除pageId
      if (!this.editState) delete params.pageId

      this.$Spin.show()
      this.saving = true
      addLandPage(params)
        .then((data) => {
          this.saving = false
          this.$Spin.hide()
          if (data) {
            this.$Message.success({
              closable: true,
              duration: 2,
              content: '提交成功！页面将 2 秒后自动关闭'
            })
            timeout(3000).then(() => {
              window.close()
            })
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    }
  },
  data() {
    return {
      saving: null,
      formErr: null, // 表单检验状态
      errRes: [], // 错误的数值
      show: null, // 选择颜色模块弹框

      htmlCode: HTML_CODE.trim(), // 母版HTML
      groupData: [], // 游戏组
      gamesList: [], // 游戏
      pages: {
        pageId: this.$route.query.id,
        pageName: '',
        pageInnerName: '',
        gameGroupId: '',
        multGame: '',
        urlType: 1,
        iosUrl: '',
        androidUrl: '',
        bgColor: '#fefeff',
        bgImage: ''
      }, // 落地页参数
      pos: {}
    }
  },
  created() {
    this.preloadData()
  },
  mounted() {
    this.$nextTick(() => {
      const top = this.$refs.phone.offsetTop
      const height = this.$refs.phone.offsetHeight
      this.pos = { top, bottom: top + height }
    })
  }
}
</script>
<style lang="scss" scoped>
.c-view {
  height: 100%;
  display: flex;
  flex: auto;
  flex-direction: row-reverse;

  .c-attribe {
    width: 544px;
    height: inherit;
    padding: 20px 16px;
    flex: 0 0 auto;
    background-color: #fff;
    z-index: 5;

    .c-panel {
      height: 100%;
    }

    ::v-deep .ivu-tabs-content {
      padding: 20px 0;
      position: relative;
      z-index: 9;
    }

    .c-group-submit {
      padding: 15px;
      background-color: #fff;
      border-top: 1px solid #eaeaea;
    }

    ::v-deep .ivu-tabs {
      overflow-y: auto;
      scrollbar-width: thin;
      -webkit-overflow-scrolling: touch;

      scrollbar-width: thin;
      height: calc(100% - 107px);
    }
  }

  .c-phone {
    height: inherit;
    min-width: 500px;
    flex: auto;
    padding: 58px 0;

    .c-p-box {
      width: 100%;
      height: 100%;
      position: relative;
      z-index: 5;
      overflow: hidden;

      header {
        margin: 0 auto;
        box-shadow: 1px 1px 7px 1px #e8e8e8;
        width: 375px;
        height: 64px;
        position: relative;

        .h-title {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          width: 70%;
          position: absolute;
          left: 15%;
          bottom: 0;
          line-height: 44px;
          font-size: 14px;
          font-weight: 500;
          color: #666;
          text-align: center;
        }
      }

      .c-p-content {
        width: calc(100% + 8px);
        height: calc(100% - 64px);
        overflow-x: hidden;
        overflow-y: scroll;
        scrollbar-width: thin;
        -webkit-overflow-scrolling: touch;

        .before-div {
          width: 375px;
          height: 100%;
          position: absolute;
          z-index: -1;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          background-position: center center;
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
    }
  }
}

.c-btns {
  text-align: right;
}

::v-deep .c-check-wrapper {
  min-width: unset;
}
</style>
